const STAFF_ROLES = ['superadmin', 'admin', 'staff']
const CLIENT_ROLES = Object.freeze(['transporter', 'transportasset', 'passenger'])
const AGENT_EXTRA_ROLES = Object.freeze(['agentstaff', 'agentdriver', 'terminalsupervisor'])
const SMARTTRANSIT_ROLES = Object.freeze(['superadmin', 'admin', 'staff', 'investor', 'vendor'].concat(AGENT_EXTRA_ROLES))
const AGENT_FAMILY_ROLES = Object.freeze(['agent'].concat(AGENT_EXTRA_ROLES))
const ALL_ROLES = Object.freeze(SMARTTRANSIT_ROLES.concat(CLIENT_ROLES).concat(['agent']))

const ROLE_HIERARCHY = {
  superadmin: ['superadmin'],
  admin: ['superadmin', 'admin'],
  staff: STAFF_ROLES.slice(),
  staffIncludingInvestor: ['superadmin', 'admin', 'staff', 'investor'],
  staffNoInvestor: STAFF_ROLES.slice(),
  investor: ['superadmin', 'investor'],
  transporter: ['superadmin', 'admin', 'staff', 'investor', 'transporter'],
  vendor: ['superadmin', 'admin', 'vendor'],
  transportasset: ['superadmin', 'admin', 'staff', 'transportstaff'],
  agent: ['superadmin', 'admin'].concat(AGENT_FAMILY_ROLES),
  agentstaff: ['superadmin', 'admin', 'agentstaff', 'terminalsupervisor'],
  agentdriver: ['superadmin', 'admin', 'agentdriver', 'terminalsupervisor'],
  terminalsupervisor: ['superadmin', 'admin', 'terminalsupervisor']
}

function getRoleNames (user) {
  if (!user || !Array.isArray(user.roles)) {
    return []
  }

  const names = []
  for (let i = 0; i < user.roles.length; i++) {
    const role = user.roles[i]
    if (typeof role === 'string') {
      names.push(role)
    } else if (role && role.name) {
      names.push(role.name)
    }
  }
  return names
}

function userHasAnyRole (user, roleNames) {
  if (!roleNames || !roleNames.length) {
    return false
  }

  const names = getRoleNames(user)
  for (let i = 0; i < names.length; i++) {
    if (roleNames.indexOf(names[i]) !== -1) {
      return true
    }
  }
  return false
}

function rolesSatisfying (requestedRole) {
  if (!requestedRole) {
    return []
  }
  const matching = ROLE_HIERARCHY[requestedRole]
  if (matching) {
    return matching.slice()
  }
  return [requestedRole]
}

function isAuthorized (user, role) {
  if (!user || !role) {
    return false
  }
  return userHasAnyRole(user, rolesSatisfying(role))
}

const AGENT_EXTRA_ROLE_KEYS = {
  agentstaff: 'asAgentStaff',
  agentdriver: 'asAgentDriver',
  terminalsupervisor: 'asTerminalSupervisor'
}

const AGENT_EXTRA_ROLE_LABELS = {
  agentstaff: 'Agent Staff',
  agentdriver: 'Agent Driver',
  terminalsupervisor: 'Terminal Supervisor'
}

function effectiveAgentExtraRoles (roleNames) {
  const has = {}
  const names = roleNames || []
  for (let i = 0; i < names.length; i++) {
    has[names[i]] = true
  }
  return {
    agentstaff: !!(has.agentstaff || has.terminalsupervisor),
    agentdriver: !!(has.agentdriver || has.terminalsupervisor),
    terminalsupervisor: !!has.terminalsupervisor
  }
}

function describeStoredExtraRoleChanges (fromFlags, toFlags) {
  const changes = []
  for (let i = 0; i < AGENT_EXTRA_ROLES.length; i++) {
    const roleName = AGENT_EXTRA_ROLES[i]
    const key = AGENT_EXTRA_ROLE_KEYS[roleName]
    const wasOn = !!(fromFlags && fromFlags[key])
    const willBeOn = !!(toFlags && toFlags[key])
    if (wasOn !== willBeOn) {
      changes.push((willBeOn ? 'Add ' : 'Remove ') + AGENT_EXTRA_ROLE_LABELS[roleName])
    }
  }
  return changes
}

function hasAgentStaffPrivileges (roles) {
  return userHasAnyRole({ roles: roles || [] }, ['agentstaff', 'terminalsupervisor'])
}

module.exports = {
  CLIENT_ROLES,
  SMARTTRANSIT_ROLES,
  AGENT_EXTRA_ROLES,
  AGENT_FAMILY_ROLES,
  ALL_ROLES,
  ROLE_HIERARCHY,
  getRoleNames,
  userHasAnyRole,
  rolesSatisfying,
  isAuthorized,
  AGENT_EXTRA_ROLE_LABELS,
  effectiveAgentExtraRoles,
  describeStoredExtraRoleChanges,
  hasAgentStaffPrivileges
}
